module.exports = __webpack_public_path__ + "static/media/KM.f84361c5.jpg";